export default {
  pageDecorate: {
    "ariaEdit": "编辑",
    "graphicNavCountSuffix": "个导航",
    "lbl_02ddb4554d": "收货人：",
    "lbl_040a5c16c7": "自动充值扣款比例：",
    "lbl_04a534f3a5": "纳税人识别号：",
    "lbl_056f2d7df6": "导航",
    "lbl_08363955f4": "返回按钮",
    "lbl_091fc2d76d": "话机：",
    "lbl_0a6bfb272d": "标签颜色",
    "lbl_0bc5794fd2": "工单标题",
    "lbl_0bc8ac93ec": "是否多校：",
    "lbl_0bf6cc005b": "校区标签：",
    "lbl_0cab5bf687": "设备信息:",
    "lbl_0cf2fe2914": "辅助线颜色",
    "lbl_0e1bf7ba51": "工单创建人",
    "lbl_0fad5de61c": "文字高度",
    "lbl_102c00ea4d": "联系邮箱：",
    "lbl_15d02f961d": "页面边距",
    "lbl_16090bee10": "发票抬头：",
    "lbl_1745f209df": "商品角标",
    "lbl_18200de7cd": "优惠信息",
    "lbl_182e9afbb9": "视频链接",
    "lbl_19983fa06e": "SN码:",
    "lbl_1a10cd6599": "描述内容",
    "lbl_1a3adde2f2": "发票税号:",
    "lbl_1ab25b87cb": "总部leads投放计划：",
    "lbl_1c76748802": "文本粗细",
    "lbl_1d720cd466": "开户行账号：",
    "lbl_1ee75f16f0": "小班课小学定价：",
    "lbl_207424204a": "最多可容纳：",
    "lbl_21b48fa906": "签约经理：",
    "lbl_21bebbe5cd": "采购单号:",
    "lbl_22b03c024d": "二维码",
    "lbl_255f442c4a": "自定义颜色",
    "lbl_257ccf2b58": "描述粗细",
    "lbl_25aa43b508": "初中化学教材版本:",
    "lbl_281e8c354f": "联系方式：",
    "lbl_282f51d840": "收费方案：",
    "lbl_29771b8f9e": "班级数:",
    "lbl_29efe66996": "代理商ID:",
    "lbl_2c31f81f00": "房租/年：",
    "lbl_30bf42e112": "快递公司:",
    "lbl_30d2f82d09": "IP地址：",
    "lbl_32c65d8d74": "标题",
    "lbl_32dab3b09c": "是否自动播放",
    "lbl_344f459e96": "真实姓名:",
    "lbl_366f6dd487": "卡片样式",
    "lbl_371a3b9108": "收货地址:",
    "lbl_3a737c66f0": "密码:",
    "lbl_3a8647306e": "标题位置",
    "lbl_3b33ac4d19": "文本颜色",
    "lbl_3bdd08adab": "描述",
    "lbl_3c6b686d4d": "小学数学教材版本:",
    "lbl_3d4ac6ea3b": "笔记标签",
    "lbl_3d96b8f799": "一屏显示",
    "lbl_3e07996cd2": "所在地:",
    "lbl_3f5e9a64a6": "学校人数:",
    "lbl_3ffa035102": "验证码:",
    "lbl_402b79ad66": "扫一扫",
    "lbl_405ac6e226": "变更前",
    "lbl_409120b562": "个人中心",
    "lbl_41a9331ca3": "商品样式",
    "lbl_41fe816cd3": "手机号：",
    "lbl_42b6206979": "入口图片",
    "lbl_42bda62972": "营业执照附件：",
    "lbl_43ab9af06e": "标题内容",
    "lbl_4573a75803": "背景颜色",
    "lbl_45bc0c40d4": "是否开通双重订单：",
    "lbl_4621eae280": "小班课高中定价：",
    "lbl_484973fb2b": "空白高度",
    "lbl_49dbfdd7e4": "付款流水:",
    "lbl_4a16588c34": "收货人联系方式：",
    "lbl_4a1e658c10": "框体颜色",
    "lbl_4c7c3fffe6": "摄像头：",
    "lbl_4d7a2304e8": "报名信息设置（多选）：",
    "lbl_518bbd63ec": "代理标签：",
    "lbl_5317cd7fb9": "未选中的颜色",
    "lbl_5721abf1f2": "收货人:",
    "lbl_575bba6bd2": "房租/月：",
    "lbl_5831dd1cd2": "招生邮箱：",
    "lbl_5a0fe6ca08": "附件：",
    "lbl_5a16b5f797": "开通费:",
    "lbl_5a766e6b9f": "文件用途:",
    "lbl_5a7f7cff87": "可开门店数：",
    "lbl_5aa955d842": "校区ID：",
    "lbl_5d765cbf1b": "签约人联系地址：",
    "lbl_5e59e7365a": "批次号:",
    "lbl_5f4907d97c": "发票抬头:",
    "lbl_617db300df": "活动跟进人：",
    "lbl_6245552bbd": "描述颜色",
    "lbl_64b2cc3410": "充值话费：",
    "lbl_65ca794f12": "高中语文教材版本:",
    "lbl_6781e352d0": "初中英语教材版本:",
    "lbl_67acecd161": "身份证号：",
    "lbl_68cfd3dffb": "校区地址:",
    "lbl_6b36c6f7ec": "颜色",
    "lbl_6b3acbf150": "支持人员：",
    "lbl_6cca2719c8": "协同信息",
    "lbl_6cf50c210b": "手写板：",
    "lbl_6d45fffeee": "左右边距",
    "lbl_6fc0e71744": "学校省市区:",
    "lbl_7035c62fb0": "账号",
    "lbl_706d07c4cc": "法人姓名：",
    "lbl_70e84c0387": "框体高度",
    "lbl_7192bf129c": "验证码：",
    "lbl_7245f2c049": "商品间距",
    "lbl_742e0c20ea": "高中物理教材版本:",
    "lbl_75c1f8c8b6": "详细地址：",
    "lbl_765de7391a": "教程版本：",
    "lbl_7664627e74": "标题粗细",
    "lbl_76a3a16ff1": "渠道：",
    "lbl_776b1ca3c2": "跳转页面",
    "lbl_778476b73d": "合计支付:",
    "lbl_787b5677e3": "性别",
    "lbl_7acf573116": "小班课小学原始定价：",
    "lbl_7d76f1c6fb": "高亮位置",
    "lbl_7e08855457": "收货人手机:",
    "lbl_7eacb4d906": "真实姓名",
    "lbl_7ec907e705": "文字颜色",
    "lbl_7f1bb5b5c3": "大班课初中定价：",
    "lbl_82e19e683d": "小班课高中原始定价：",
    "lbl_856474a71d": "开户行：",
    "lbl_85adfe7fbd": "厂商:",
    "lbl_85f581a05d": "大班课小学定价：",
    "lbl_8627bfd5e5": "工单详情",
    "lbl_8896d6e909": "变更后",
    "lbl_898a701cac": "教室数：",
    "lbl_8a01952db2": "定价系数：",
    "lbl_8d2317049c": "默认颜色",
    "lbl_8f7c576579": "片区信息",
    "lbl_8fd3f6dc0b": "快递手机号:",
    "lbl_90b8640967": "营业执照号：",
    "lbl_90ef7c485b": "查看更多",
    "lbl_915a911788": "校区性质：",
    "lbl_91fe07e2e3": "登录账号：",
    "lbl_9233da5b5a": "商户号：",
    "lbl_9384861fd6": "套餐费:",
    "lbl_93ab99d761": "文字大小",
    "lbl_93bd60528b": "文本位置",
    "lbl_9440e4bdd0": "购买按钮",
    "lbl_945e635a60": "描述大小",
    "lbl_94a34827d2": "资料信息",
    "lbl_94e391ba46": "标题颜色",
    "lbl_986d366b99": "联系人姓名",
    "lbl_98749f006c": "年级:",
    "lbl_991e5e07de": "领取上限（每日）：",
    "lbl_994b3edae7": "标题大小",
    "lbl_99fa0ccf6f": "小班课初中原始定价：",
    "lbl_99fb57a4f7": "电销人员：",
    "lbl_9aac36099a": "框体样式",
    "lbl_9c3929baa4": "账号:",
    "lbl_9c81917214": "科目：",
    "lbl_9cf4c6ad6e": "商品价格",
    "lbl_9ff563bded": "初始账户:",
    "lbl_a0a0862ca5": "合同编号:",
    "lbl_a0a837f287": "显示位置",
    "lbl_a0f441a6bd": "初中数学教材版本:",
    "lbl_a321a3cff2": "当前余额：",
    "lbl_a34ccadd92": "寄宿情况:",
    "lbl_a4091ad20a": "学校概况：:",
    "lbl_a5791b7ddc": "开户银行：",
    "lbl_a594615071": "校区评星：",
    "lbl_a5c887f3fe": "招生电话：",
    "lbl_a5f3056296": "高中数学教材版本:",
    "lbl_a641cfff1d": "图片边距",
    "lbl_a6695e3433": "联系邮箱",
    "lbl_a789515f85": "高中化学教材版本:",
    "lbl_a810520460": "密码",
    "lbl_a96b9768a1": "小班课初中定价：",
    "lbl_abf8f48093": "页面描述",
    "lbl_ac188aeae0": "公众号Id",
    "lbl_ac8cfdfb57": "选中的颜色",
    "lbl_ad22c45df8": "电脑：",
    "lbl_adac24db4a": "选择模板",
    "lbl_adbf7600a3": "图片间隙",
    "lbl_af315fecb2": "大班课高中定价：",
    "lbl_af3abf07ec": "合同签约经理:",
    "lbl_b0d7ee1533": "学校信息",
    "lbl_b1aa8e7d07": "天猫优品店ID：",
    "lbl_b4491c5317": "新手机号：",
    "lbl_b44ba0ddca": "合同附件",
    "lbl_b530b8b44f": "总部在线支付：",
    "lbl_b5894313c2": "联系方式",
    "lbl_b678141cb4": "商户：",
    "lbl_bcf71e7c75": "原手机号：",
    "lbl_c182ad6b97": "左侧图标",
    "lbl_c1df04eec5": "高度",
    "lbl_c6b4d76e64": "电话：",
    "lbl_c9a6ee90f5": "附件",
    "lbl_c9b55e60bf": "左侧标题",
    "lbl_cc19463999": "文件签署经理:",
    "lbl_cd6c4172d8": "初中语文教材版本:",
    "lbl_cf4424d749": "高中英语教材版本:",
    "lbl_d2a877b42b": "付款方式:",
    "lbl_d4d2a66820": "位置",
    "lbl_d53bad00d1": "右侧内容",
    "lbl_d748497cb5": "背景图片",
    "lbl_d7a47ec7e8": "账号：",
    "lbl_db261a0107": "小学语文教材版本:",
    "lbl_dcc86dbfdf": "开通月数:",
    "lbl_ddbe1d7bf0": "校区面积：",
    "lbl_dec2eb7145": "跳转链接",
    "lbl_df3833270b": "地址：",
    "lbl_e20a8291f1": "待支付：",
    "lbl_e243f649cb": "联系方式:",
    "lbl_e245764011": "图片倒角",
    "lbl_e2e09fb16a": "外边框",
    "lbl_e512d692b9": "收货地址：",
    "lbl_e55a8735e9": "签约信息",
    "lbl_e853cf8ef7": "报名成功提醒：",
    "lbl_e8835aceaa": "快递单号:",
    "lbl_ea1e0dbccc": "图片样式",
    "lbl_eab3ad101b": "变更记录",
    "lbl_eeb70ad310": "阅读数",
    "lbl_f0b8bdd4aa": "学段:",
    "lbl_f14633eb92": "签约主体：",
    "lbl_f5a1e7a18a": "封面链接",
    "lbl_f757e0bc38": "阶段年级：",
    "lbl_f82dbb8a4a": "手机号查看上限（每日）：",
    "lbl_f8867b393b": "底部分割线",
    "lbl_fa33129586": "首笔提货款提现限额：",
    "lbl_fa86f1a57d": "公告",
    "lbl_fa895c4eb5": "小学英语教材版本:",
    "lbl_fd67478677": "ID打卡机：",
    "lbl_fd71364919": "一行个数",
    "lbl_fd98c9567f": "选择样式",
    "lbl_fe411c66be": "初中物理教材版本:",
    "lbl_fea3394875": "公众号图片",
    "lbl_febbf6c0c3": "点赞数",
    "workOrderSubmitAt": "工单提交时间",
  }
}
